import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface BulkImportStatusResponse {
  success: boolean;
  job: BulkImportJob;
}

export interface BulkImportJob {
  jobId: string;
  status: 'queued' | 'processing' | 'completed' | 'failed' | 'cancelled';
  totalRecords: number;
  processedRecords: number;
  successfulEnrollments: number;
  failedEnrollments: number;
  currentEnrollment: string | null;
  progress: number;
  result?: {
    successfulEnrollments: Array<{ title: string; _id: string }>;
    failedEnrollments: Array<{
      enrollment: Record<string, string | number | undefined>;
      reason: string;
    }>;
  };
  errorMessage: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetBulkImportStatusParams {
  jobId: string;
}

export const getBulkImportClassesStatusAPI = async (
  params: GetBulkImportStatusParams,
) => {
  const response = await baseAPI.get<BulkImportStatusResponse>(
    `/enrollments/bulk-import-status/${params.jobId}`,
  );
  return response.data;
};

export const getBulkImportClassesStatusQueryOptions = (
  params: GetBulkImportStatusParams,
) =>
  queryOptions({
    queryKey: [KEYS.BULK_IMPORT_CLASSES_STATUS, params.jobId],
    queryFn: () => getBulkImportClassesStatusAPI(params),
    enabled: !!params.jobId,
  });

export const useGetBulkImportClassesStatus = (params: GetBulkImportStatusParams) => {
  return useQuery(getBulkImportClassesStatusQueryOptions(params));
};

